module.exports = __webpack_public_path__ + "static/media/slide5.f53056a4.svg";